"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerBmExpansionPanelRemoveButton = exports.BmExpansionPanelRemoveButton = exports.registerBmExpansionPanelAddButton = exports.registerBmExpansionPanel = exports.BmExpansionPanel = void 0;

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/map"));

var _element = require("@onviobr/element");

var _netUtils = require("@onviobr/net-utils");

var _bmIcon = require("./bm-icon");

var _bmIcons = require("./bm-icons");

var _bmButton = require("./bm-button");

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t\t:host .bm-button {\n\t\t\t\t\theight: 22px;\n\t\t\t\t\tbox-sizing: content-box;\n\t\t\t\t\tpadding: 0;\n\t\t\t\t}\n\t\t\t"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<button @click=\"", "\" class=\"bm-button xs primary outline\">\n\t\t\t\t", "\n\t\t\t</button>\n\t\t"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t:host {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t\t:host .add-another-row {\n\t\t\t\tdisplay: flex;\n\t\t\t\theight: 38px;\n\t\t\t\twidth: 100%;\n\t\t\t\tpadding: 0 21px;\n\t\t\t\tbackground-color: white;\n\t\t\t\tcolor: rgb(0, 53, 101);\n\t\t\t\tcolor: var(--accent-color, rgb(0, 53, 101));\n\t\t\t\talign-items: center;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tfont-weight: bold;\n\t\t\t\tfont-family: 'Helvetica Neue', Arial, sans-serif;\n\t\t\t\tborder: solid 1px rgba(221, 220, 224, 1);\n\t\t\t\tcursor: pointer;\n\t\t\t\tbox-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n\t\t\t}\n\t\t\t:host .add-another-row:hover {\n\t\t\t\tbackground-color: rgba(0, 53, 101, 0.1);\n\t\t\t\tbackground-color: var(--translucent-color, rgba(0, 53, 101, 0.1));\n\t\t\t}\n\t\t\t:host .add-another-row:active {\n\t\t\t\tbackground-color: white;\n\t\t\t}\n\n\t\t\t:host .add-another-row svg {\n\t\t\t\tmargin-right: 6px;\n\t\t\t\theight: 16px;\n\t\t\t\twidth: 16px;\n\t\t\t\tfill: rgb(0, 53, 101);\n\t\t\t\tfill: var(--accent-color, rgb(0, 53, 101));\n\t\t\t}\n\t\t"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<button class=\"bm-button link xs add-another-row\">\n\t\t\t\t", " ", "\n\t\t\t</button>"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["<span class=\"caret\"></span>"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<button\n\t\t\t\tclass=\"bm-button link xs panel-header\"\n\t\t\t\t@click=\"", "\">\n\t\t\t\t<div class=\"panel-header-left\">\n\t\t\t\t\t<slot name=\"panel-title\"></slot>\n\t\t\t\t\t<slot name=\"panel-description\"></slot>\n\t\t\t\t\t<slot name=\"panel-header-actions\"></slot>\n\t\t\t\t</div>\n\t\t\t\t", "\n\t\t\t</button>\n\t\t\t<div class=\"panel-body\">\n\t\t\t\t<slot name=\"panel-content\"></slot>\n\t\t\t\t<div class=\"panel-footer\">\n\t\t\t\t\t<slot name=\"panel-footer-actions\"></slot>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t\t:host {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\tbackground-color: rgba(0, 53, 101, 0.1);\n\t\t\t\t\tbackground-color: var(--translucent-color, rgba(0, 53, 101, 0.1));\n\t\t\t\t\tbox-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n\t\t\t\t}\n\n\t\t\t\t:host([expanded]:not(:first-child)) {\n\t\t\t\t\tmargin-top: 20px;\n\t\t\t\t}\n\t\t\t\t:host([expanded]) {\n\t\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t}\n\n\t\t\t\t:host button.bm-button.link.panel-header {\n\t\t\t\t\tpadding: 10px 24px 10px 24px;\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tcolor: black;\n\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\ttext-decoration: none;\n\t\t\t\t}\n\n\t\t\t\t:host button.bm-button.link.panel-header:hover {\n\t\t\t\t\tcolor: black;\n\t\t\t\t}\n\n\t\t\t\t:host button.bm-button.link.panel-header {\n\t\t\t\t\toutline: 0 !important;\n\t\t\t\t}\n\n\t\t\t\t:host([disabled]) button.bm-button.link.panel-header {\n\t\t\t\t\topacity: 0.5;\n\t\t\t\t\tcursor: not-allowed;\n\t\t\t\t}\n\n\t\t\t\t:host(:not([expanded])) .panel-header:hover {\n\t\t\t\t\tbackground-color: white;\n\t\t\t\t}\n\n\t\t\t\t:host .caret {\n\t\t\t\t\tpadding: 4px;\n\t\t\t\t}\n\n\t\t\t\t:host .caret::after {\n\t\t\t\t\ttransition: transform 225ms;\n\t\t\t\t}\n\n\t\t\t\t:host([expanded]) .caret::after {\n\t\t\t\t\ttransform: rotate(225deg);\n\t\t\t\t}\n\n\t\t\t\t:host .caret::after {\n\t\t\t\t\tborder-style: solid;\n\t\t\t\t\tborder-width: 0 2px 2px 0;\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\tpadding: 3px;\n\t\t\t\t\ttransform: rotate(45deg);\n\t\t\t\t\tvertical-align: middle;\n\t\t\t\t\ttransition: all 225ms;\n\t\t\t\t}\n\n\t\t\t\t:host slot[name='panel-title'] {\n\t\t\t\t\tfont-family: KnowledgeRegular, Arial, sans-serif;\n\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t}\n\t\t\t\t:host .panel-header:focus slot[name='panel-title'] {\n\t\t\t\t\ttext-decoration: underline;\n\t\t\t\t}\n\n\t\t\t\t:host(:not([expanded])) .panel-body {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t\t:host([expanded]) .panel-body {\n\t\t\t\t\tpadding-left: 24px;\n\t\t\t\t\tpadding-right: 24px;\n\t\t\t\t}\n\n\t\t\t\t:host .panel-footer {\n\t\t\t\t\tpadding-top: 10px;\n\t\t\t\t\tpadding-bottom: 10px;\n\t\t\t\t}\n\t\t\t"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function makeExpansionPanelService() {
  var groups = new _map.default();
  var groupListenerCount = new _map.default();

  function on(group, cb) {
    var _groupListenerCount$g;

    if (!groups.has(group)) {
      var groupEmitter = (0, _netUtils.eventEmitter)();
      groups.set(group, groupEmitter);
    }

    var groupSubject = groups.get(group);
    groupSubject.on('setActivePanel', cb);
    groupListenerCount.set(group, ((_groupListenerCount$g = groupListenerCount.get(group)) !== null && _groupListenerCount$g !== void 0 ? _groupListenerCount$g : 0) + 1);
    return function () {
      groupSubject.off('setActivePanel', cb);
      groupListenerCount.set(group, groupListenerCount.get(group) - 1);

      if (groupListenerCount.get(group) <= 0) {
        groups.delete(group);
        groupListenerCount.delete(group);
      }
    };
  }

  function emitActivePanel(group, panel) {
    if (groups.has(group)) {
      var groupSubject = groups.get(group);
      groupSubject.emit('setActivePanel', panel);
    }
  }

  return {
    on: on,
    emitActivePanel: emitActivePanel
  };
}

var BmExpansionPanel = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(BmExpansionPanel, _BlueElement);

  var _super = (0, _createSuper2.default)(BmExpansionPanel);

  (0, _createClass2.default)(BmExpansionPanel, null, [{
    key: "is",
    get: function get() {
      return 'bm-expansion-panel';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        expanded: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        hideCaret: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        disabled: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        group: {
          type: String,
          attribute: true,
          reflect: true
        },
        autoClose: {
          type: Boolean,
          attribute: true,
          reflect: true
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return [_bmButton.bmButtonStyle, (0, _element.css)(_templateObject())];
    }
  }]);

  function BmExpansionPanel() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, BmExpansionPanel);
    _this = _super.call(this);
    _this.expanded = false;
    _this.hideCaret = false;
    _this.disabled = false;
    _this.autoClose = false;
    _this.onActivePanelChange = (0, _bind.default)(_context = _this.onActivePanelChange).call(_context, (0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(BmExpansionPanel, [{
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this._sub) {
        this._sub();

        this._sub = null;
      }
    }
  }, {
    key: "shouldUpdate",
    value: function shouldUpdate(props) {
      if (props.has('group') && Boolean(this.group)) {
        if (this._sub) this._sub();
        this._sub = BmExpansionPanel.service.on(this.group, this.onActivePanelChange);
      }

      if (props.has('expanded') && Boolean(this.expanded) && Boolean(this.group)) {
        BmExpansionPanel.service.emitActivePanel(this.group, this);
      }

      return (0, _get2.default)((0, _getPrototypeOf2.default)(BmExpansionPanel.prototype), "shouldUpdate", this).call(this, props);
    }
  }, {
    key: "onActivePanelChange",
    value: function onActivePanelChange(_ref) {
      var activePanel = _ref.detail;

      if (this.autoClose) {
        this.expanded = this === activePanel;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.html(_templateObject2(), this.toggleExpansion, this.hideCaret ? null : this.html(_templateObject3()));
    }
  }, {
    key: "toggleExpansion",
    value: function toggleExpansion() {
      if (!this.disabled) {
        this.expanded = !this.expanded;
      }
    }
  }]);
  return BmExpansionPanel;
}(_element.BlueElement);

exports.BmExpansionPanel = BmExpansionPanel;
BmExpansionPanel.service = makeExpansionPanelService();

var registerBmExpansionPanel = function registerBmExpansionPanel() {
  (0, _element.register)(BmExpansionPanel);
};

exports.registerBmExpansionPanel = registerBmExpansionPanel;

var BmExpansionPanelAddButton = /*#__PURE__*/function (_BlueElement2) {
  (0, _inherits2.default)(BmExpansionPanelAddButton, _BlueElement2);

  var _super2 = (0, _createSuper2.default)(BmExpansionPanelAddButton);

  function BmExpansionPanelAddButton() {
    (0, _classCallCheck2.default)(this, BmExpansionPanelAddButton);
    return _super2.apply(this, arguments);
  }

  (0, _createClass2.default)(BmExpansionPanelAddButton, [{
    key: "render",
    value: function render() {
      return this.html(_templateObject4(), _bmIcons.add, this.addButtonLabel || BmExpansionPanelAddButton.defaultAddButtonLabel);
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-expansion-panel-add-button';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        addText: {
          type: String,
          attribute: false,
          reflect: false
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return (0, _element.css)(_templateObject5());
    }
  }]);
  return BmExpansionPanelAddButton;
}(_element.BlueElement);

BmExpansionPanelAddButton.defaultAddButtonLabel = 'Add';

var registerBmExpansionPanelAddButton = function registerBmExpansionPanelAddButton() {
  (0, _bmIcon.registerIcon)();
  (0, _element.register)(BmExpansionPanelAddButton);
};

exports.registerBmExpansionPanelAddButton = registerBmExpansionPanelAddButton;

var BmExpansionPanelRemoveButton = /*#__PURE__*/function (_BlueElement3) {
  (0, _inherits2.default)(BmExpansionPanelRemoveButton, _BlueElement3);

  var _super3 = (0, _createSuper2.default)(BmExpansionPanelRemoveButton);

  function BmExpansionPanelRemoveButton() {
    (0, _classCallCheck2.default)(this, BmExpansionPanelRemoveButton);
    return _super3.apply(this, arguments);
  }

  (0, _createClass2.default)(BmExpansionPanelRemoveButton, [{
    key: "render",
    value: function render() {
      return this.html(_templateObject6(), this.onRemove, this.removeButtonLabel || BmExpansionPanelRemoveButton.defaultRemoveButtonLabel);
    }
  }, {
    key: "onRemove",
    value: function onRemove(evt) {
      evt.stopPropagation();
      this.dispatchEvent(new CustomEvent('removeRow', {
        bubbles: true,
        composed: true
      }));
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-expansion-panel-remove-button';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        removeButtonLabel: {
          type: String,
          attribute: false,
          reflect: false
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return [_bmButton.bmButtonStyle, (0, _element.css)(_templateObject7())];
    }
  }]);
  return BmExpansionPanelRemoveButton;
}(_element.BlueElement);

exports.BmExpansionPanelRemoveButton = BmExpansionPanelRemoveButton;
BmExpansionPanelRemoveButton.defaultRemoveButtonLabel = 'Remove';

var registerBmExpansionPanelRemoveButton = function registerBmExpansionPanelRemoveButton() {
  (0, _element.register)(BmExpansionPanelRemoveButton);
};

exports.registerBmExpansionPanelRemoveButton = registerBmExpansionPanelRemoveButton;
